"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("../Button"));
var contexts_1 = require("../../contexts");
var FormatText_1 = __importDefault(require("../FormatText"));
var FormResetButton = function (props) {
    var formProps = react_1.useContext(contexts_1.FormContext).formProps;
    var beforeReset = props.beforeReset, afterReset = props.afterReset, noIcon = props.noIcon, children = props.children, buttonProps = __rest(props, ["beforeReset", "afterReset", "noIcon", "children"]);
    var handleClick = function (e) {
        if (formProps) {
            if (beforeReset)
                beforeReset(formProps);
            formProps.resetForm();
            if (afterReset)
                afterReset(formProps);
        }
    };
    return (react_1.default.createElement(Button_1.default, __assign({ icon: noIcon ? undefined : 'commons-cancel', onClick: handleClick }, buttonProps), children || react_1.default.createElement(FormatText_1.default, { id: "ui.commons.form.reset", uppercase: true })));
};
exports.default = FormResetButton;
